<template>
  <div class="time-picker">
    <v-menu
      :close-on-content-click="false"
      full-width
      lazy
      max-width="40px"
      min-width="400px"
      offset-y
      ref="menu"
      transition="scale-transition"
      v-model="menu2"
    >
      <v-text-field
        :value="value"
        @change="changeTime"
        slot="activator"
        v-bind="$attrs"
        v-on="$listeners"
      ></v-text-field>
      <v-card>
        <v-card-text>
          <v-container>
            <v-layout row>
              <v-flex style="height:300px;overflow-y:auto;overflow-x:hidden;" xs6>
                <v-btn
                  :class="{active: i===hour}"
                  :key="i"
                  @click="selectHour(i)"
                  flat
                  v-for="i in hours"
                >{{i}}</v-btn>
              </v-flex>
              <v-flex style="height:300px;overflow:auto;" xs6>
                <v-btn
                  :class="{active: i===minue}"
                  :key="i"
                  @click="selectMinue(i)"
                  flat
                  v-for="i in minues"
                >{{i}}</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="menu2=false" flat>Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      menu2: false,
      hours: [],
      minues: [],
      hour: '00',
      minue: '00'
    }
  },
  created() {
    for (let i = 0; i < 24; i++) {
      this.hours.push(('0' + i).slice(-2))
    }
    for (let i = 0; i < 60; i++) {
      this.minues.push(('0' + i).slice(-2))
    }
  },
  watch: {
    value(v) {
      v = v || '00:00'
      let parts = v.split(':')
      this.hour = parts[0]
      this.minue = parts[1]
    }
  },
  methods: {
    selectHour(i) {
      this.hour = i
      this.$emit('input', `${i}:${this.minue}`)
    },
    selectMinue(i) {
      this.minue = i
      this.$emit('input', `${this.hour}:${i}`)
    },
    changeTime(v) {
      if (v.indexOf(':') === -1) {
        this.hour = (v + '0000').substr(0, 2)
        this.minue = (v + '0000').substr(2, 2)
        this.$emit('input', `${this.hour}:${this.minue}`)
      } else {
        this.$emit('input', v)
      }
    }
  }
}
</script>

<style scoped>
.active {
  background: #ccc;
}
</style>

